export default __webpack_public_path__ + "static/media/table-search.aad1a53a.svg";